import { render, staticRenderFns } from "./saintbrand-infinite-marquee.vue?vue&type=template&id=d5e5b61a&scoped=true&"
import script from "./saintbrand-infinite-marquee.vue?vue&type=script&lang=js&"
export * from "./saintbrand-infinite-marquee.vue?vue&type=script&lang=js&"
import style0 from "./saintbrand-infinite-marquee.vue?vue&type=style&index=0&id=d5e5b61a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e5b61a",
  null
  
)

export default component.exports